module.exports = __webpack_public_path__ + "static/media/fal_fal_she_fan.cf344044.png";